export default () => ({
    noteContent: '',
    isEditing: false,
    isEditable: false,
    csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    activityId: null,
    userId: null,
    async activityTeacherNotesInit() {
        this.isEditable = this.$refs?.editor?.dataset?.editable === "true";
        this.activityId = this.$root.dataset.activityId || null;
        this.userId = this.$root.dataset.userId || null;
        const textArea = this.$refs?.editor.querySelector('textarea');
        if (textArea) {
            // Load note content from local storage if available
            const storedContent = localStorage.getItem(`activityNote-${this.userId}-${this.activityId}`);
            if (storedContent) {
                this.noteContent = storedContent;
            }
            // Add event listener to update local storage on input
            textArea.addEventListener('input', () => {
                this.noteContent = textArea.value;
                this.updateLocalStorageOnTypeInTextArea();
            });
        }
        await this.fetchNote()
    },
    async fetchNote() {
        const response = await fetch(`/resources/notes/${this.activityId}/`);

        if (!response.ok) {
            console.error('Failed to fetch note:', response.statusText);
            return;
        }
        const data = await response.json();
        this.noteContent = data.content || '';
        if (!this.noteContent) {
            this.isEditing = true;
        }
    },
    editNote() {
        this.isEditing = true;
        const storedContent = localStorage.getItem(`activityNote-${this.userId}-${this.activityId}`);
        if (storedContent) {
            this.noteContent = storedContent;
        }
    },
    async deleteNote() {
        const response = await fetch(`/resources/notes/${this.activityId}/delete/`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': this.csrfToken,
            },
        })
        if (!response.ok) {
            console.error('Failed to delete note:', response.statusText);
            return;
        }
        const data = await response.json();
        this.noteContent = data.content || '';
        this.isEditing = true;
        this.clearLocalStorage();
    },
    async cancelNote() {
        this.isEditing = false;
        await this.fetchNote(); // Re-fetch the note to restore original content
    },
    async saveNote() {
        if (this.noteContent.trim() === '') {
            alert('Note content cannot be empty.');
            return;
        }
        const response = await fetch(`/resources/notes/${this.activityId}/save/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': this.csrfToken,
            },
            body: JSON.stringify({
                content: this.noteContent,
            }),
        });
        if (!response.ok) {
            console.error('Failed to save note:', response.statusText);
            return;
        }
        const data = await response.json();
        this.noteContent = data.content || '';
        this.isEditing = false;
        this.clearLocalStorage();
    },
    updateLocalStorageOnTypeInTextArea() {
        localStorage.setItem(`activityNote-${this.userId}-${this.activityId}`, this.noteContent);
    },
    clearLocalStorage() {
        // Clear the local storage for this note
        localStorage.removeItem(`activityNote-${this.userId}-${this.activityId}`);
    }
})